export default __webpack_public_path__ + "static/Home-Computador-13a6d0f73a04359731b49499872d6dfe.png";